import { RouterModule } from '@angular/router';
import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { OuiIconModule } from 'omnium-ui/icon';
import { OuiTooltipModule } from 'omnium-ui/tooltip';
import { appRoutePaths } from '../../../app.paths';
import {
  ConsultantTagStatus,
  getConsultantStatusLabel,
} from '../../../features/applications/shared/consultant-status-tag/consultant-status-tag.component';

@Component({
  selector: 'dbw-consultant-card',
  imports: [RouterModule, OuiIconModule, OuiTooltipModule],
  templateUrl: './consultant-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './consultant-card.component.scss',
})
export class ConsultantCardComponent {
  readonly id = input<number | null | undefined>(undefined);
  readonly code = input.required<string>();
  readonly name = input.required<string>();
  readonly statusCode = input<string | number | null | undefined>(undefined);

  readonly link = computed(() => {
    const consultantId = this.id();
    return consultantId === null || consultantId === undefined
      ? null
      : appRoutePaths.atlas.consultant(consultantId);
  });
  readonly statusLabel = computed(() => getConsultantStatusLabel(this.statusCode()));
  readonly tagStatus = computed<ConsultantTagStatus>(() => {
    switch (this.statusCode()?.toString().trim()) {
      case '1':
        return 'completed';
      case '4':
        return 'in-progress';
      case '0':
      case '5':
        return 'transition';
      case '2':
      case '6':
        return 'pending';
      case '3':
        return 'error';
      default:
        return 'pending';
    }
  });
}
